module.exports = "<div class=\"loader-wrapper\">\r\n  <span class=\"loader\"></span>\r\n</div>\r\n"